import axios from "axios";

// export const baseURL = `http://192.168.1.128:8000`;
// export const baseURL = `http://192.168.1.162:8000`;
export const baseURL = window.location.origin;

// ADMIN INSTANCE
const API = axios.create({ baseURL: `${baseURL}/v1` });
API.interceptors.request.use((req) => {
    let token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
        localStorage.setItem('appToken', "7f8a73448952efb2811ebd40a72f090a");
    }
    return req;
});

// APP INSTANCE
const APP_API = axios.create({ baseURL: `${baseURL}/v1` });
APP_API.interceptors.request.use((req) => {
    let appToken = localStorage.getItem('appToken');
    if (appToken) {
        req.headers.Authorization = `${appToken}`;
    }
    return req;
})

// ADMIN APIS
export const adminSigninAPI = async (payload) => API.post(`/admin/signIn`, payload);

// DASHBOARD APIS
export const getDashboardAPI = async () => API.get(`/admin/dashboard`);

// COUNTRY AND REGION APIS
export const getCountryAPI = async () => API.get(`/admin/getCountry`);
export const getRegionAPI = async () => API.get(`/admin/getRegion`);

// SLIDERS APIS
export const getSlidersAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getSlider?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getSlider`)
    }
};
export const addSlidersAPI = async (payload) => API.post(`/admin/addSlider`, payload);
export const updateSlidersAPI = async (payload, id) => API.patch(`/admin/updateSlider?id=${id}`, payload);
export const deleteSlidersAPI = async (id) => API.delete(`/admin/deleteSlider?id=${id}`);
export const deleteAllSlidersAPI = async (payload) => API.post(`/admin/deleteAllSlider`, payload);

// SLIDER TAG APIS
export const getSliderTagAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search) {
        return API.post(`/admin/getSliderTag?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getSliderTag`)
    }
}
export const addSliderTagAPI = async (payload) => API.post(`/admin/addSliderTag`, payload);
export const updateSliderTagAPI = async (payload, id) => API.patch(`/admin/updateSliderTag?id=${id}`, payload);
export const deleteSliderTagAPI = async (id) => API.delete(`/admin/deleteSliderTag?id=${id}`);
export const deleteAllSliderTagAPI = async (payload) => API.post(`/admin/deleteAllSliderTag`, payload);

// THEMES APIS
export const getThemesAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search) {
        return API.post(`/admin/getTheme?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getTheme`)
    }
};
export const addThemeAPI = async (payload) => API.post(`/admin/addTheme`, payload);
export const updateThemeAPI = async (payload, id) => API.patch(`/admin/updateTheme?id=${id}`, payload);
export const deleteThemeAPI = async (id) => API.delete(`/admin/deleteTheme?id=${id}`);
export const deleteAllThemesAPI = async (payload) => API.post(`/admin/deleteAllTheme`, payload);

// THEME CATEGORIES APIS
export const getThemeCategoryAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search) {
        return API.post(`/admin/getCategory?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getCategory`)
    }
};
export const addThemeCategoryAPI = async (payload) => API.post(`/admin/addCategory`, payload);
export const updateThemeCategoryAPI = async (payload, id) => API.patch(`/admin/updateCategory?id=${id}`, payload);
export const deleteThemeCategoryAPI = async (id) => API.delete(`/admin/deleteCategory?id=${id}`);
export const deleteAllCategoryAPI = async (payload) => API.post(`/admin/deleteAllCategory`, payload);

// THEMES TAG APIS
export const getTagAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search) {
        return API.post(`/admin/getTag?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getTag`)
    }
}
export const addTagAPI = async (payload) => API.post(`/admin/addTag`, payload);
export const updateTagAPI = async (payload, id) => API.patch(`/admin/updateTag?id=${id}`, payload);
export const deleteUpdateTagAPI = async (id) => API.delete(`/admin/deleteUpdateTag?id=${id}`);
export const deleteAllTagAPI = async (payload) => API.post(`/admin/deleteAllTag`, payload);

// BACKGROUND APIS
export const getBackgroundAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getBackgroundlist?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getBackgroundlist`)
    }
}
export const addBackgroundAPI = async (payload) => API.post(`/admin/addBackgroundlist`, payload);
export const updateBackgroundAPI = async (payload, id) => API.patch(`/admin/updateBackgroundlist?id=${id}`, payload);
export const deleteBackgroundAPI = async (id) => API.delete(`/admin/deleteBackgroundlist?id=${id}`);
export const deleteAllBackgroundAPI = async (payload) => API.post(`/admin/deleteAllBackgroundlist`, payload);

// BACKGROUND CATEGORIES APIS
export const getBackgroundCategoryAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getBackgroundCategory?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getBackgroundCategory`)
    }
};
export const addBackgroundCategoryAPI = async (payload) => API.post(`/admin/addBackgroundCategory`, payload);
export const updateBackgroundCategoryAPI = async (payload, id) => API.patch(`/admin/updateBackgroundCategory?id=${id}`, payload);
export const deleteBackgroundCategoryAPI = async (id) => API.delete(`/admin/deleteBackgroundCategory?id=${id}`);
export const deleteAllBackgroundCategoryAPI = async (payload) => API.post(`/admin/deleteAllBackgroundCategory`, payload);

// EFFECTS APIS
export const getEffectsAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getEffect?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getEffect`)
    }
}
export const addEffectAPI = async (payload) => API.post(`/admin/addEffect`, payload);
export const updateEffectAPI = async (payload, id) => API.patch(`/admin/updateEffect?id=${id}`, payload);
export const deleteEffectAPI = async (id) => API.delete(`/admin/deleteEffect?id=${id}`);
export const deleteAllEffectAPI = async (payload) => API.post(`/admin/deleteAllEffect`, payload);

// FONTLISTS APIS
export const getFontListAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getFontlist?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getFontlist`)
    }
}
export const addFontListAPI = async (payload) => API.post(`/admin/addFontlist`, payload);
export const updateFontListAPI = async (payload, id) => API.patch(`/admin/updateFontlist?id=${id}`, payload);
export const deleteFontListsAPI = async (id) => API.delete(`/admin/deleteFontlist?id=${id}`);
export const deleteAllFontlistAPI = async (payload) => API.post(`/admin/deleteAllFontlist`, payload);

// SOUNDS APIS
export const getSoundsAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getSoundlist?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getSoundlist`)
    }
}
export const addSoundsAPI = async (payload) => API.post(`/admin/addSoundlist`, payload);
export const updateSoundsAPI = async (payload, id) => API.patch(`/admin/updateSoundlist?id=${id}`, payload);
export const deleteSoundsAPI = async (id) => API.delete(`/admin/deleteSoundlist?id=${id}`);
export const deleteAllSoundlistAPI = async (payload) => API.post(`/admin/deleteAllSoundlist`, payload);

// STICKERSTORE APIS
export const getStickerStoreAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getStickerStore?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getStickerStore`)
    }
}
export const addStickerStoreAPI = async (payload) => API.post(`/admin/addStickerStore`, payload);
export const updateStickerStoreAPI = async (payload, id) => API.patch(`/admin/updateStickerStore?id=${id}`, payload);
export const deleteStickerStoreAPI = async (id) => API.delete(`/admin/deleteStickerStore?id=${id}`);
export const deleteAllStickerStoreAPI = async (payload) => API.post(`/admin/deleteAllStickerStore`, payload);

// SETTING API
export const addSettingAPI = async (payload) => API.post(`/admin/addSetting`, payload);

// WALLPAPER API
export const getWallpaperAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.get(`/admin/getWallpaper?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.get(`/admin/getWallpaper`)
    }
}
export const addWallpaperAPI = async (payload) => API.post(`/admin/addWallpaper`, payload);
export const updateWallpaperAPI = async (payload, id) => API.patch(`/admin/updateWallpaper?id=${id}`, payload);
export const deleteWallpaperAPI = async (id) => API.delete(`/admin/deleteWallpaper?id=${id}`);
export const deleteAllWallpaperAPI = async (payload) => API.post(`/admin/deleteAllWallpaperlist`, payload);


// WALLPAPER CATEGORIES API
export const getWallpaperCategoryAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/getWallpaperCategory?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/getWallpaperCategory`)
    }
};
export const addWallpaperCategoryAPI = async (payload) => API.post(`/admin/addWallpaperCategory`, payload);
export const updateWallpaperCategoryAPI = async (payload, id) => API.patch(`/admin/updateWallpaperCategory?id=${id}`, payload);
export const deleteWallpaperCategoryAPI = async (id) => API.delete(`/admin/deleteWallpaperCategory?id=${id}`);
export const deleteAllWallpaperCategoryAPI = async (payload) => API.post(`/admin/deleteAllWallpaperCategory`, payload);

// HISTORY API
export const getHistoryAPI = async (_currentPage, _perPage, _search, _filterDropdown) => {
    if (_currentPage || _perPage || _search || _filterDropdown) {
        return API.post(`/admin/history?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    } else {
        return API.post(`/admin/history`)
    }
};
export const deleteAllHistoryAPI = async (payload) => API.post(`/admin/deleteHistory`, payload);


// APP_API API
export const getAppCategoryAPI = async () => APP_API.post(`/theme/getCategory`);
export const getAppCategoryDataAPI = async (_payload, _page, _perPage) => APP_API.post(`/theme/getTheme`, _payload);
